import { gql } from "@apollo/client";

export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput) {
    createUser(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_USER_WITH_PAGINATION = gql`
  query GetUserPagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
    $role: UserRole
  ) {
    getUserPagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
      role: $role
    ) {
      data {
        _id
        profile
        gender
        phoneNumber
        email
        role
        firstNameKh
        lastNameKh
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;


export const GET_USER_LOGIN = gql`
  query GetUserLogin {
    getUserLogin {
      isSuccess
      token
      message {
        messageKh
        messageEn
      }
      user {
        _id
        profile
        gender
        phoneNumber
        email
        role
        lastNameKh
        firstNameKh
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_USER = gql`
mutation UpdateUser($id: ID!, $input: UpdateUserInput) {
  updateUser(_id: $id, input: $input) {
    isSuccess
    message {
      messageKh
      messageEn
    }
  }
}
`;

export const CHANGE_USER_PASSWORD = gql`
  mutation ChangeUserPassword($id: ID!, $newPassword: String) {
    changeUserPassword(_id: $id, newPassword: $newPassword) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const USER_LOGIN = gql`
  mutation UserLogin($email: String!, $password: String!) {
    userLogin(email: $email, password: $password) {
      isSuccess
      message {
        messageKh
        messageEn
      }
      token
      user {
        _id
        profile
        gender
        email
        role
        phoneNumber
        lastNameKh
        firstNameKh
      }
    }
  }
`;
